module.exports = __webpack_public_path__ + "img/hudiejie.938181d3.png";